import { API_BASE_URL } from "../config";
import React, { useState, useEffect } from "react";
import axios from "axios";

const WithdrawalQueue = () => {
  const [withdrawals, setWithdrawals] = useState([]);
  const [loading, setLoading] = useState(true);
  const [settings, setSettings] = useState(null);

  // Reject Modal State
  const [selectedTx, setSelectedTx] = useState(null);
  const [rejectionReason, setRejectionReason] = useState("");
  const [processing, setProcessing] = useState(false);

  const fetchWithdrawals = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${API_BASE_URL}/api/admin/withdrawals`);
      setWithdrawals(Array.isArray(res.data) ? res.data : (res.data?.Withdrawals?.toLowerCase() || res.data?.data || res.data?.items || res.data?.users || res.data?.trades || res.data?.holdings || res.data?.positions || res.data?.orders || res.data?.logs || res.data?.withdrawals || []));
      const settingsRes = await axios.get(`${API_BASE_URL}/api/admin/settings`);
      setSettings(settingsRes.data);
    } catch (err) {
      console.error("Error fetching withdrawal queue", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchWithdrawals();
  }, []);

  const handleApprove = async (txId) => {
    if (!window.confirm("Are you sure you want to approve this withdrawal request?")) return;
    try {
      await axios.post(`${API_BASE_URL}/api/admin/withdrawals/${txId}/action`, {
        action: "approve",
      });
      fetchWithdrawals();
    } catch (err) {
      alert(err.response?.data?.message || "Approval failed");
    }
  };

  const handleRejectSubmit = async (e) => {
    e.preventDefault();
    if (!rejectionReason) return alert("Rejection reason is required");
    setProcessing(true);

    try {
      await axios.post(`${API_BASE_URL}/api/admin/withdrawals/${selectedTx._id}/action`, {
        action: "reject",
        rejectionReason,
      });
      setSelectedTx(null);
      setRejectionReason("");
      fetchWithdrawals();
    } catch (err) {
      alert(err.response?.data?.message || "Rejection failed");
    } finally {
      setProcessing(false);
    }
  };

  const pendingList = withdrawals.filter((w) => w.status === "pending");
  const processedList = withdrawals.filter((w) => w.status !== "pending");

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px" }}>
        <div>
          <h2 style={{ margin: 0, color: "#fff" }}>Fund Withdrawal Approval Queue</h2>
          <p style={{ margin: "4px 0 0", color: "#b2b5be", fontSize: "14px" }}>
            Review, approve, or reject client paper-trading withdrawal requests
          </p>
        </div>

        {settings && (
          <div style={{ backgroundColor: "#1e222d", padding: "8px 14px", borderRadius: "6px", border: "1px solid #2a2e39", fontSize: "13px", color: "#b2b5be" }}>
            ⚡ Tiered Threshold: Under <strong>₹{settings.autoApproveWithdrawalThreshold?.toLocaleString()}</strong> Auto-Approved
          </div>
        )}
      </div>

      {/* Pending Queue Section */}
      <div style={{ backgroundColor: "#1e222d", borderRadius: "8px", overflow: "hidden", border: "1px solid #2a2e39", marginBottom: "30px" }}>
        <div style={{ padding: "16px", borderBottom: "1px solid #2a2e39", backgroundColor: "rgba(255, 152, 0, 0.08)" }}>
          <h3 style={{ margin: 0, color: "#ffb74d", fontSize: "16px" }}>
            ⏳ Pending Action Requests ({pendingList.length})
          </h3>
        </div>

        {loading ? (
          <div style={{ padding: "20px", color: "#888" }}>Loading pending queue...</div>
        ) : pendingList.length === 0 ? (
          <div style={{ padding: "24px", color: "#888", textAlign: "center" }}>No pending withdrawal requests in queue.</div>
        ) : (
          <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "13px" }}>
            <thead>
              <tr style={{ backgroundColor: "#2a2e39", color: "#b2b5be", textAlign: "left" }}>
                <th style={thStyle}>Requested Date</th>
                <th style={thStyle}>Client User</th>
                <th style={thStyle}>KYC Status</th>
                <th style={thStyle}>Requested Amount</th>
                <th style={thStyle}>Notes / Payout info</th>
                <th style={thStyle}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {pendingList.map((w) => {
                const client = w.userId || {};
                return (
                  <tr key={w._id} style={{ borderBottom: "1px solid #2a2e39" }}>
                    <td style={tdStyle}>{new Date(w.requestedAt).toLocaleString()}</td>
                    <td style={tdStyle}>
                      <div><strong>{client.name || "N/A"}</strong></div>
                      <div style={{ fontSize: "11px", color: "#888" }}>{client.email}</div>
                    </td>
                    <td style={tdStyle}>
                      <span
                        style={{
                          padding: "2px 8px",
                          borderRadius: "10px",
                          fontSize: "11px",
                          fontWeight: "bold",
                          backgroundColor: client.kycStatus === "verified" ? "rgba(76, 175, 80, 0.15)" : "rgba(239, 83, 80, 0.15)",
                          color: client.kycStatus === "verified" ? "#4caf50" : "#ef5350",
                        }}
                      >
                        {client.kycStatus?.toUpperCase()}
                      </span>
                    </td>
                    <td style={{ ...tdStyle, fontWeight: "bold", color: "#ef5350", fontSize: "15px" }}>
                      ₹{w.amount?.toLocaleString('en-IN')}
                    </td>
                    <td style={tdStyle}>{w.notes || "-"}</td>
                    <td style={tdStyle}>
                      <div style={{ display: "flex", gap: "8px" }}>
                        <button onClick={() => handleApprove(w._id)} style={approveBtnStyle}>
                          ✓ Approve
                        </button>
                        <button onClick={() => setSelectedTx(w)} style={rejectBtnStyle}>
                          ✕ Reject
                        </button>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>

      {/* History Log */}
      <div style={{ backgroundColor: "#1e222d", borderRadius: "8px", overflow: "hidden", border: "1px solid #2a2e39" }}>
        <div style={{ padding: "16px", borderBottom: "1px solid #2a2e39" }}>
          <h3 style={{ margin: 0, color: "#fff", fontSize: "16px" }}>Historical Withdrawal Decisions ({processedList.length})</h3>
        </div>

        <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "13px" }}>
          <thead>
            <tr style={{ backgroundColor: "#2a2e39", color: "#b2b5be", textAlign: "left" }}>
              <th style={thStyle}>Decision Date</th>
              <th style={thStyle}>Client</th>
              <th style={thStyle}>Amount</th>
              <th style={thStyle}>Final Status</th>
              <th style={thStyle}>Actioned By</th>
              <th style={thStyle}>Rejection Reason / Notes</th>
            </tr>
          </thead>
          <tbody>
            {processedList.map((w) => (
              <tr key={w._id} style={{ borderBottom: "1px solid #2a2e39" }}>
                <td style={tdStyle}>{w.processedAt ? new Date(w.processedAt).toLocaleString() : "-"}</td>
                <td style={tdStyle}>{w.userId?.name || "N/A"}</td>
                <td style={{ ...tdStyle, fontWeight: "bold" }}>₹{w.amount?.toLocaleString()}</td>
                <td style={tdStyle}>
                  <span
                    style={{
                      padding: "2px 8px",
                      borderRadius: "10px",
                      fontSize: "11px",
                      fontWeight: "bold",
                      backgroundColor: w.status === "approved" || w.status === "completed" ? "rgba(76, 175, 80, 0.15)" : "rgba(239, 83, 80, 0.15)",
                      color: w.status === "approved" || w.status === "completed" ? "#4caf50" : "#ef5350",
                    }}
                  >
                    {w.status.toUpperCase()}
                  </span>
                </td>
                <td style={tdStyle}>{w.processedBy?.name || "System"}</td>
                <td style={{ ...tdStyle, color: "#888" }}>{w.rejectionReason || w.notes || "-"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Reject Modal */}
      {selectedTx && (
        <div style={modalOverlayStyle}>
          <div style={modalContentStyle}>
            <h3 style={{ marginTop: 0, color: "#ef5350" }}>Reject Withdrawal Request</h3>
            <p style={{ fontSize: "13px", color: "#b2b5be" }}>
              Provide a clear reason for rejecting ₹{selectedTx.amount?.toLocaleString()} request for {selectedTx.userId?.name}.
            </p>

            <form onSubmit={handleRejectSubmit}>
              <div style={{ marginBottom: "14px" }}>
                <label style={labelStyle}>Rejection Reason (Required)</label>
                <textarea
                  rows={3}
                  value={rejectionReason}
                  onChange={(e) => setRejectionReason(e.target.value)}
                  placeholder="e.g. Bank account mismatch or pending KYC documentation"
                  required
                  style={{ ...inputStyle, fontFamily: "inherit" }}
                />
              </div>

              <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px", marginTop: "20px" }}>
                <button type="button" onClick={() => setSelectedTx(null)} style={cancelBtnStyle}>Cancel</button>
                <button type="submit" disabled={processing} style={rejectBtnStyle}>
                  {processing ? "Rejecting..." : "Confirm Rejection"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

const thStyle = { padding: "12px", fontSize: "12px", textTransform: "uppercase" };
const tdStyle = { padding: "12px", color: "#d1d4dc" };

const approveBtnStyle = {
  padding: "6px 12px",
  backgroundColor: "#2e7d32",
  color: "#fff",
  border: "none",
  borderRadius: "4px",
  fontWeight: "bold",
  cursor: "pointer",
  fontSize: "12px",
};

const rejectBtnStyle = {
  padding: "6px 12px",
  backgroundColor: "#c62828",
  color: "#fff",
  border: "none",
  borderRadius: "4px",
  fontWeight: "bold",
  cursor: "pointer",
  fontSize: "12px",
};

const cancelBtnStyle = {
  padding: "8px 16px",
  backgroundColor: "#2a2e39",
  color: "#fff",
  border: "1px solid #363c4e",
  borderRadius: "4px",
  cursor: "pointer",
};

const modalOverlayStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: "rgba(0,0,0,0.7)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 2000,
};

const modalContentStyle = {
  backgroundColor: "#2a2e39",
  padding: "24px",
  borderRadius: "10px",
  width: "100%",
  maxWidth: "460px",
  color: "#fff",
};

const labelStyle = {
  display: "block",
  fontSize: "13px",
  fontWeight: 500,
  marginBottom: "6px",
  color: "#d1d4dc",
};

const inputStyle = {
  width: "100%",
  padding: "10px",
  borderRadius: "6px",
  border: "1px solid #434651",
  backgroundColor: "#1e222d",
  color: "#fff",
  fontSize: "14px",
  boxSizing: "border-box",
};

export default WithdrawalQueue;
